import { ValidationProps } from 'ui';
import { ComplexValue, Value } from 'app/types-shared';
import { LoadCodeItemsParams } from 'app/area/code-mappings/types';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export interface CodeMappingValue extends ComplexValue<number> {
  ctg?: number;
}
export interface SearchCodeModel {
  selectedIds: Value[];
  negated?: boolean;
}

export interface CodeMappingsListItems {
  id?: string;
  description?: string;
  codetable: CodeMappingValue;
  code?: CodeMappingValue;
  codeCategory?: CodeMappingValue;
}

export interface CodeMappingsListState {
  requestId: number;
  fetchingList: boolean;
  fetchingItemId: number;
  fileName: ComplexValue<number>;
  importSet: ComplexValue<number>;
  missingMappingsExists: boolean;
  listItems: CodeMappingsListItems[];
  codetableIds: string[];
  updatingExternalValue: boolean;
  modifiedItems: ModifiedCodeMappings[];
  validation: { [key: string]: ValidationProps };
  codetableOptions: {
    [key: string]: {
      fetching: boolean;
      codes: CodeComplexValue<number>[];
      currentOptions: CodeComplexValue<number>[];
      loadOptionsParams?: LoadCodeItemsParams;
    };
  };
  fetchingCodetableAccess: number;
  codetableAccess: AccessCodetable;
  metadata: CodetableMetadata;
  fetchingMetadata: number;
}

export interface AccessCodetable {
  id: number;
  create: boolean;
  administrationCentral: boolean;
}

export interface ModifiedCodeMappings {
  id: string;
  codetable: number;
  description: string;
  code?: ComplexValue<number>;
  codeCategory?: ComplexValue<number>;
}

export interface ModifiedCodeMappingsModel {
  codetableId: number;
  mappings: {
    externalValue: string;
    code: number;
  }[];
}

export interface PostSearchFinalData {
  id: string;
  description: string;
  codetable: ComplexValue<number>;
  code: ComplexValue<number>;
  codeCategory: ComplexValue<number>;
}

export interface GroupedResult {
  [key: string]: {
    id: string;
    codetable: ComplexValue<number>;
    description: string;
    code: ComplexValue<number>;
    codeCategory: ComplexValue<number>;
  }[];
}

export interface AccessCodetable {
  id: number;
  create: boolean;
  administrationCentral: boolean;
}

export enum CodeFieldWireKey {
  code = 'code',
  codeCategory = 'codeCategory'
}

export type CodetablesAccessWire = AccessCodetable[];

export type CodeFormName = string;

export interface CodeFieldWire {
  id: number;
  searchRequired: boolean;
  label?: string;
}

export enum CodeFieldFlagWireKey {
  disabled = 'disabled',
}

export type CodeFieldFlagsWire = { [key in keyof typeof CodeFieldFlagWireKey]: boolean; };

export type CodeLanguageField = {
  description: boolean;
  longDescription: boolean;
};


export interface CodeMetadataWire extends CodeFieldFlagsWire {
  formName: CodeFormName;
  label: string;
  code: CodeFieldWire;
}


export interface CodeField {
  id: number;
  searchRequired: boolean;
  label?: string;
}


export enum CodetableFeature {
  disabled = 'disabled'
}

export type CodetableFeatures = {
  [key in CodetableFeature]?: boolean;
};

export interface CodetableMetadata {
  formName: CodeFormName;
  codetable: CodeField;
  label: string;
  features: CodetableFeatures;
}
